// Utils
import stripFileExtension from '../../../../common/files/stripFileExtension';
import randomString from '../../../../common/uid/randomString';

export const appendToFilename = (filename: string) => {
    const [base = '', ...rest] = filename.split('.');

    return [`${base}-${randomString(6)}`, ...rest].join('.');
};

/**
 * Replace or append an extension on a filename.
 */
export const replaceFileExtension = (filename: string, extension: string): string => {
    const normalizedExtension = extension.replace(/^\./, '');
    return `${stripFileExtension(filename)}.${normalizedExtension}`;
};

type UploadFileBlob = Blob & { name: string; lastModified: number };

/**
 * Attach upload metadata expected by the image upload pipeline.
 */
export const enrichBlobAsUploadFile = (blob: Blob, filename: string): UploadFileBlob =>
    Object.assign(blob, {
        name: filename,
        lastModified: Date.now(),
    }) as UploadFileBlob;
